import { Component, OnInit } from '@angular/core';
import { ToasterService } from 'src/app/modules/shared/services/toaster/toaster.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  public loading: boolean = false;
  public dummy_word: string = '';

  constructor(
    private Toaster: ToasterService
  ) { }

  public info() {
    this.Toaster.info(`You typed the word ${this.dummy_word}`, 2000);
  }

  public success() {
    this.Toaster.success(`You typed the word ${this.dummy_word}`, 2000);
  }

  public warning() {
    this.Toaster.warning(`You typed the word ${this.dummy_word}`, 2000);
  }

  ngOnInit(): void {
  }

}
